import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const CONSENT_KEY = 'venueintel_cookie_consent';

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-16 lg:bottom-0 left-0 right-0 z-30 border-t border-border bg-background/95 backdrop-blur-lg px-4 py-4 sm:px-6 lg:pl-72">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
        <p className="text-sm text-muted-foreground text-center sm:text-left">
          We use essential cookies to keep you signed in and improve your experience. Learn more in
          our{' '}
          <Link to="/privacy" className="text-primary hover:underline">
            Privacy Policy
          </Link>
          .
        </p>
        <Button size="sm" onClick={accept} className="shrink-0">
          Got it
        </Button>
      </div>
    </div>
  );
}
